"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Popup =
/*#__PURE__*/
function () {
  function Popup(link, headline, content) {
    _classCallCheck(this, Popup);

    this.body = $('body');
    this.container = $('#popup');
    this.containerContent = $('#popup div');
    this.overlay = $('#overlay');
    this.closeButton = $('#overlay, #close-button');
    this.headline = headline;
    this.content = content;
    this.link = $(link);
    this.openPopup();
    this.closePopup();
  }

  _createClass(Popup, [{
    key: "fillPopup",
    value: function fillPopup() {
      this.containerContent.html('<h2>' + this.headline + '</h2><p>' + this.content + '</p>');
    }
  }, {
    key: "openPopup",
    value: function openPopup() {
      var _this = this;

      this.link.click(function (e) {
        e.preventDefault();

        _this.body.addClass('lock');

        _this.overlay.fadeIn(0);

        _this.container.fadeIn(300);

        _this.fillPopup();
      });
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      var _this2 = this;

      this.closeButton.click(function (e) {
        e.preventDefault();

        _this2.body.removeClass('lock');

        _this2.overlay.fadeOut(0);

        _this2.container.fadeOut(300);
      });
    }
  }]);

  return Popup;
}();